export class ChangePassword {
    newpassword: string;
    username: string;
    rtop:string
    constructor(newpassword: string, username: string ,ROTP:string) {
        this.newpassword = newpassword;
        this.username = username;
        this.rtop =  ROTP;
    }
}